module.exports = __webpack_public_path__ + "static/media/la_kinfolk_dinner_20.391111f6.jpg";